import { fetchWithBodyTemplateFn } from './base/fetch-with-body-template-fn';

export const updateTemplateFn = fetchWithBodyTemplateFn('PUT');
